import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/core/services/store'
import { isUserLoggedIn } from '@/auth/utils'
import { canNavigate } from '@/core/utils/acl/routeProtection'
import VueCompositionAPI from '@vue/composition-api'

Vue.config.productionTip = false

// Global 3rd party plugins
import 'popper.js'
import 'tooltip.js'
import PerfectScrollbar from 'perfect-scrollbar'
window.PerfectScrollbar = PerfectScrollbar
import ClipboardJS from 'clipboard'
window.ClipboardJS = ClipboardJS

// Vue 3rd party plugins
import i18n from '@/core/plugins/vue-i18n'
import vuetify from '@/core/plugins/vuetify'
import VuePusher from 'vue-pusher'
import '@/core/utils/acl'
import '@/core/plugins/portal-vue'
import '@/core/plugins/bootstrap-vue'
import '@/core/plugins/perfect-scrollbar'
import '@/core/plugins/highlight-js'
import '@/core/plugins/inline-svg'
import '@/core/plugins/treeselect'
import '@/core/plugins/toastification'
import '@/core/plugins/apexcharts'
import '@/core/plugins/flat-pickr'
import '@/core/plugins/signature'
import '@/core/plugins/metronic'
import '@mdi/font/css/materialdesignicons.css'

// Composition API
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

Vue.prototype.$variableGlobal = Vue.observable({
  facility: null,
})

// API service init
/* ApiService.init(); */

Vue.use(VuePusher, {
  api_key: process.env.VUE_APP_PUSHER_KEY,
  options: {
    cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    authEndpoint: `${process.env.VUE_APP_RUTA_API}/api/broadcasting/auth`,
    encrypted: true,
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    },
  },
})
// Rutas públicas (sin autenticación)
const publicRoutes = [
  'get-cupon',
  'landing-home',
  'plan-verification',
  'contact',
  'providers',
  'laboratorios',
  'telemedicina',
]

router.beforeEach((to, _, next) => {
  // Manejar hash #contact para redirigir a la página de contacto
  if (window.location.hash === '#contact' && to.path !== '/contact') {
    return next('/contact')
  }

  const isLoggedIn = isUserLoggedIn()
  let parsedUser = null
  let isInsuranceAgent = false
  let isAdminAgent = false

  // Si es ruta pública, permitir acceso sin verificación
  // Pero si está logueado y es member o agent plan, redirigir a su dashboard
  if (to.meta.public || publicRoutes.includes(to.name)) {
    if (to.name === 'landing-home' && isLoggedIn) {
      const storedUser = localStorage.getItem('userData')
      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser)
          const isMember =
            Array.isArray(parsedUser?.roles) &&
            parsedUser.roles.some(role => Number(role.id) === 10)
          const isAgentPlan =
            Array.isArray(parsedUser?.roles) &&
            parsedUser.roles.some(role => Number(role.id) === 9)

          if (isMember) {
            return next({ name: 'member-dashboard' })
          }
          if (isAgentPlan) {
            return next({ name: 'agent-plan-dashboard' })
          }
        } catch (error) {
          // Si hay error, continuar con la ruta pública
        }
      }
    }
    return next()
  }

  const storedUser = localStorage.getItem('userData')
  let isMember = false
  let isAgentPlan = false

  if (storedUser) {
    try {
      parsedUser = JSON.parse(storedUser)
      isInsuranceAgent =
        Array.isArray(parsedUser?.roles) &&
        parsedUser.roles.some(role => Number(role.id) === 7)
      isAdminAgent =
        Array.isArray(parsedUser?.roles) &&
        parsedUser.roles.some(role => Number(role.id) === 8)
      isMember =
        Array.isArray(parsedUser?.roles) &&
        parsedUser.roles.some(role => Number(role.id) === 10)
      isAgentPlan =
        Array.isArray(parsedUser?.roles) &&
        parsedUser.roles.some(role => Number(role.id) === 9)
    } catch (error) {
      isInsuranceAgent = false
    }
  }

  if (
    isLoggedIn &&
    isInsuranceAgent &&
    to.name !== 'insurance-agent-dashboard' &&
    to.name !== 'insurance-agent-patients' &&
    to.name !== 'insurance-agent-payment-info' &&
    to.name !== 'insurance-agent-request-appointment' &&
    to.name !== 'insurance-calendario' &&
    !publicRoutes.includes(to.name) &&
    to.name !== '404'
  ) {
    return next({ name: 'insurance-agent-dashboard' })
  }

  if (
    isLoggedIn &&
    isAdminAgent &&
    to.name !== 'admin-agent-dashboard' &&
    !publicRoutes.includes(to.name) &&
    to.name !== '404'
  ) {
    return next({ name: 'admin-agent-dashboard' })
  }

  if (
    isLoggedIn &&
    isMember &&
    to.name !== 'member-dashboard' &&
    to.name !== 'member-add-plan' &&
    !publicRoutes.includes(to.name) &&
    to.name !== '404'
  ) {
    return next({ name: 'member-dashboard' })
  }

  if (
    isLoggedIn &&
    isAgentPlan &&
    to.name !== 'agent-plan-dashboard' &&
    to.name !== 'agent-plan-add-member' &&
    to.name !== 'agent-plan-members' &&
    !publicRoutes.includes(to.name) &&
    to.name !== '404'
  ) {
    return next({ name: 'agent-plan-dashboard' })
  }

  if (!publicRoutes.includes(to.name)) {
    if (!canNavigate(to)) {
      if (!isLoggedIn) return next({ name: 'login' })
      return next({ name: '404' })
    }
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
      if (isInsuranceAgent) {
        return next({ name: 'insurance-agent-dashboard' })
      }
      if (isAdminAgent) {
        return next({ name: 'admin-agent-dashboard' })
      }
      if (isMember) {
        return next({ name: 'member-dashboard' })
      }
      if (isAgentPlan) {
        return next({ name: 'agent-plan-dashboard' })
      }
      return next({ name: 'dashboard' })
    }
  }

  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)

  return next()
})

// Al cambiar entre páginas de landing, siempre scroll al inicio
router.afterEach((to) => {
  if (to.meta.layout === 'landing') {
    const scrollToTop = () => {
      window.scrollTo(0, 0)
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
    scrollToTop()
    setTimeout(scrollToTop, 50)
    setTimeout(scrollToTop, 150)
  }
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
